// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Filter48Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Filter48: FC<Filter48Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="48"
            height="48"
        >
            <path d="M26 18.5v-3h6.5V6h3v9.5H42v3H26ZM32.5 42V21.5h3V42h-3Zm-20 0v-9H6v-3h16v3h-6.5v9h-3Zm0-15V6h3v21h-3Z" />
        </svg>
    );
};

export default Filter48;
